module.exports = __webpack_public_path__ + "static/logo-28824e48067210d1e49cdb6830202274.png";